import React from "react";

const LABELS = {
  available: "Verfügbar",
  rented: "Verliehen",
  maintenance: "Wartung",
  retired: "Ausgemustert",
  active: "Aktiv",
  returned: "Zurück",
};

export default function StatusBadge({ status }) {
  const label = LABELS[status] || status;
  const cls = `badge badge-${status}` + (LABELS[status] ? "" : " bg-gray-200 text-gray-600");
  return <span className={cls}>{label}</span>;
}
